import api from '@/services/api';
export default {
    async getAll({ dispatch, commit }, params) {
        const { data } = await api.get('/api/classes', { params });
        return data;
    },
    async getByFilter({ dispatch, commit }, params) {
        const { data } = await api.get('/api/classes/get-by-filter', { params });
        return data;
    },

}